import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { parseRoute, pathForPage, pathForPageWithHash, getPageLocale, isSupportedLocale } from '../routes.js';

/**
 * Current locale/page from URL and helpers for localized links.
 *
 * @returns {object}
 */
export function useLocaleRoute() {
  const location = useLocation();

  const { locale, page } = useMemo(
    () => {
      const route = parseRoute(location.pathname);
      const queryLocale = new URLSearchParams(location.search).get('lng');
      return isSupportedLocale(queryLocale) ? { ...route, locale: getPageLocale(route.page, queryLocale) } : route;
    },
    [location.pathname, location.search]
  );

  /**
   * @param {string} targetPage
   * @param {string} [hash]
   * @returns {string}
   */
  const localizedPath = (targetPage, hash) => {
    if (hash) {
      return pathForPageWithHash(targetPage, locale, hash);
    }

    return pathForPage(targetPage, locale);
  };

  return { locale, page, localizedPath, pathname: location.pathname, hash: location.hash };
}
